/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pre-op-addl-assessment.reducer';

export const PreOpAddlAssessmentDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const preOpAddlAssessmentEntity = useAppSelector(state => state.preOpAddlAssessment.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="preOpAddlAssessmentDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.preOpAddlAssessment.detail.title">PreOpAddlAssessment</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.preOpAddlAssessment.id">Id</Translate>
            </span>
          </dt>
          <dd>{preOpAddlAssessmentEntity.id}</dd>
          <dt>
            <span id="history">
              <Translate contentKey="tinyMedicRestApp.preOpAddlAssessment.history">History</Translate>
            </span>
          </dt>
          <dd>{preOpAddlAssessmentEntity.history}</dd>
          <dt>
            <span id="clinicalFindings">
              <Translate contentKey="tinyMedicRestApp.preOpAddlAssessment.clinicalFindings">Clinical Findings</Translate>
            </span>
          </dt>
          <dd>{preOpAddlAssessmentEntity.clinicalFindings}</dd>
          <dt>
            <span id="specificInvestigations">
              <Translate contentKey="tinyMedicRestApp.preOpAddlAssessment.specificInvestigations">Specific Investigations</Translate>
            </span>
          </dt>
          <dd>{preOpAddlAssessmentEntity.specificInvestigations}</dd>
          <dt>
            <span id="medicalAssessment">
              <Translate contentKey="tinyMedicRestApp.preOpAddlAssessment.medicalAssessment">Medical Assessment</Translate>
            </span>
          </dt>
          <dd>{preOpAddlAssessmentEntity.medicalAssessment}</dd>
          <dt>
            <span id="medicalAssessmentNotes">
              <Translate contentKey="tinyMedicRestApp.preOpAddlAssessment.medicalAssessmentNotes">Medical Assessment Notes</Translate>
            </span>
          </dt>
          <dd>{preOpAddlAssessmentEntity.medicalAssessmentNotes}</dd>
          <dt>
            <span id="medicalCondition">
              <Translate contentKey="tinyMedicRestApp.preOpAddlAssessment.medicalCondition">Medical Condition</Translate>
            </span>
          </dt>
          <dd>{preOpAddlAssessmentEntity.medicalCondition}</dd>
          <dt>
            <span id="medicalConditionNotes">
              <Translate contentKey="tinyMedicRestApp.preOpAddlAssessment.medicalConditionNotes">Medical Condition Notes</Translate>
            </span>
          </dt>
          <dd>{preOpAddlAssessmentEntity.medicalConditionNotes}</dd>
          <dt>
            <span id="instructions">
              <Translate contentKey="tinyMedicRestApp.preOpAddlAssessment.instructions">Instructions</Translate>
            </span>
          </dt>
          <dd>{preOpAddlAssessmentEntity.instructions}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.preOpAddlAssessment.active">Active</Translate>
            </span>
          </dt>
          <dd>{preOpAddlAssessmentEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.preOpAddlAssessment.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{preOpAddlAssessmentEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.preOpAddlAssessment.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{preOpAddlAssessmentEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.preOpAddlAssessment.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{preOpAddlAssessmentEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.preOpAddlAssessment.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{preOpAddlAssessmentEntity.timestampentry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.preOpAddlAssessment.surgery">Surgery</Translate>
          </dt>
          <dd>{preOpAddlAssessmentEntity.surgery ? preOpAddlAssessmentEntity.surgery.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.preOpAddlAssessment.reviewedBy">Reviewed By</Translate>
          </dt>
          <dd>{preOpAddlAssessmentEntity.reviewedBy ? preOpAddlAssessmentEntity.reviewedBy.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pre-op-addl-assessment" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pre-op-addl-assessment/${preOpAddlAssessmentEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PreOpAddlAssessmentDetail;
